import { frontendTranslations } from "common/i18n/frontend/translations";

import { getUserPreferences } from "./user-preferences";

import type { FrontendLanguage, FrontendTranslations } from "common/i18n/frontend/translations";

export const getBrowserLanguage = (): FrontendLanguage => {
  const languages = navigator.languages ?? [navigator.language];
  const prefixes = languages.map((language) => language.split(`-`)[0]);
  const supportedLanguage = prefixes.find((prefix) => prefix === `es` || prefix === `pt` || prefix === `en`);
  const result = supportedLanguage ?? `en`;

  return result;
};

// languagePreference: 'auto' | 'en' | 'es' | 'pt'
export const getPreferredLanguage = (): FrontendLanguage => {
  const prefs = getUserPreferences();
  const stored = prefs.language;

  if (stored === `auto`) {
    return getBrowserLanguage();
  }

  if (stored === `en` || stored === `es` || stored === `pt`) {
    return stored;
  }

  return getBrowserLanguage();
};

export const getFrontendTranslations = (language: FrontendLanguage = getPreferredLanguage()): FrontendTranslations =>
  frontendTranslations[language];
